export const PAGINATION_DEFAULT_SIZE = 30;
